import AntProgress, { ProgressProps as AntProgressProps } from 'antd/es/progress';

export interface ProgressProps extends AntProgressProps {
  total: number;
  current: number;
}

export const Progress = ({ total, current, ...rest }: ProgressProps) => {
  return <AntProgress percent={(current / total) * 100} {...rest} />;
};
